// affiliate-community
export const AFFILIATES_FINDER_PATH = '/affiliates/affiliates-finder';
export const MY_COMMUNITY_PATH = '/affiliates/my-community';
export const MY_LISTS_PATH = '/affiliates/my-lists';
export const ADD_CREATORS_FROM_COMMUNITY_PATH = '/affiliates/my-lists/editing';

// campaign setup
export const COLLABORATION_REVIEW_PATH = '/collaborations/collaboration-review';
export const CAMPAIGN_DETAIL_PATH = '/collaborations/id';
export const TTS_CAMPAIGN_SETUP_PATH = '/collaborations/campaign-setup/tiktok-shop';
export const YTS_CAMPAIGN_SETUP_PATH = '/collaborations/campaign-setup/youtube-shopping';

// samples management
export const TTS_SAMPLES_MANAGEMENT_PATH = '/collaborations/samples-management/tiktok-shop';
export const YTS_SAMPLES_MANAGEMENT_PATH = '/collaborations/samples-management/youtube-shopping';

// crm
export const CREATE_SEQUENCE_PATH = '/crm/create-sequence';
export const DUPLICATE_SEQUENCE_PATH = '/crm/duplicate-sequence';
export const EDIT_SEQUENCE_PATH = '/crm/edit-sequence';
export const MY_SEQUENCES_PATH = '/crm/my-sequences';
export const MY_TEMPLATES_PATH = '/crm/my-templates';

// data analytics
export const YTS_DATA_ANALYTICS_PATH = '/data-analytics/youtube-shopping';

export const TTS_DATA_ANALYTICS_PATH = '/data-analytics/tiktok-shop';
export const TTS_ANALYTICS_PERFORMANCE_OVERVIEW_PATH = '/data-analytics/tiktok-shop/performance-overview';
export const TTS_ANALYTICS_PERFORMANCE_DASHBOARD_PATH = '/data-analytics/tiktok-shop/performance-dashboard';
export const TTS_ANALYTICS_OUTREACH_PERFORMANCE_PATH = '/data-analytics/tiktok-shop/outreach-performance';
export const TTS_ANALYTICS_AD_PERFORMANCE_PATH = '/data-analytics/tiktok-shop/ad-performance';
export const TTS_ANALYTICS_PRODUCT_PERFORMANCE_PATH = '/data-analytics/tiktok-shop/product-performance';
export const TTS_ANALYTICS_COLLABORATION_PERFORMANCE_PATH = '/data-analytics/tiktok-shop/collaboration-performance';
export const TTS_ANALYTICS_VIDEO_PERFORMANCE_PATH = '/data-analytics/tiktok-shop/video-performance';
export const TTS_ANALYTICS_TOP_CREATORS_PATH = '/data-analytics/tiktok-shop/top-creators';
export const TTS_ANALYTICS_SAMPLES_BY_TIER_DASHBOARD_PATH = '/data-analytics/tiktok-shop/samples-by-tier-dashboard';

// settings
export const SETTINGS_PATH = '/settings';

// profile
export const BILLING_PAYMENTS_PATH = '/profiles/billing/payments';
export const BILLING_PAYMENT_METHODS_PATH = '/profiles/billing/payment-methods';
export const MY_ACCOUNT_PATH = '/profiles/account/my-account';
export const PRICING_PATH = '/profiles/account/pricing';

// payments
export const ADD_PAYMENT_PATH = '/add-payment';
